import styled, { css } from 'styled-components';

// CONSTANTS
import { theme } from '../../constants/theme';

interface ContainerProps {
  active: boolean;
  leftSide?: boolean;
  rightSide?: boolean;
}

export const Container = styled.div<ContainerProps>`
  z-index: 1;
  display: none;
  position: absolute;
  top: 52px;
  min-width: 267px;
  max-width: 100%;
  background: ${theme.colors.primary.white};
  border: 1px solid ${theme.colors.primary.transparentBg};
  border-radius: 8px;
  box-sizing: border-box;
  box-shadow: 20px 0px 30px -10px rgba(0, 0, 0, 0.07), -20px 0px 20px -10px rgba(0, 0, 0, 0.07),
    0px 20px 30px -10px rgba(0, 0, 0, 0.08);
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};

  ${({ leftSide }) =>
    leftSide &&
    css`
      left: 0;
    `}

  ${({ rightSide }) =>
    rightSide &&
    css`
      right: 30%;
    `}

  ${({ active }) =>
    active &&
    css`
      display: block;
    `}
`;

export const Options = styled.div<{ hasScroll: boolean }>`
  flex-wrap: wrap;
  padding: 18px 26px 0 20px;

  ${({ hasScroll }) =>
    hasScroll &&
    css`
      max-height: 370px;
      overflow-y: scroll;
    `}
`;

export const Actions = styled.div`
  display: flex;
  padding: 13px 26px 13px 20px;
  border-top: 1px solid ${theme.colors.primary.transparentBg};
  justify-content: space-between;

  &:hover {
    background: ${theme.colors.primary.transparentBg};
  }
`;

export const Button = styled.button<{ disabled: boolean }>`
  padding: 0;
  outline: 0;
  border: none;
  cursor: pointer;
  background: none;
  font-size: 13px;
  line-height: 24px;
  font-family: 'Clan Pro';
  font-weight: ${theme.weights.semibold};
  color: ${theme.colors.primary.bariBlue};

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      color: ${theme.colors.states.disabled};
    `}
`;

export const IconContainer = styled.div<{ disabled: boolean }>`
  display: flex;

  svg {
    path {
      fill: ${theme.colors.primary.bariBlue};
    }
  }

  ${({ disabled }) =>
    disabled &&
    css`
      svg {
        cursor: not-allowed;
        path {
          fill: ${theme.colors.states.disabled};
        }
      }
    `}
`;
